'use client'
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google'

const NEXT_PUBLIC_GOOGLE_ANALYTICS = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS
const NEXT_PUBLIC_GOOGLE_TAG_MANAGER = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER
const GoogleTagAnalytics = () => {
	if (!NEXT_PUBLIC_GOOGLE_ANALYTICS || !NEXT_PUBLIC_GOOGLE_TAG_MANAGER) {
		console.log('GoogleTagAnalytics not initialized')
		return null
	}

	console.log('GoogleTagAnalytics initialized')

	return (
		<>
			<GoogleAnalytics gaId={NEXT_PUBLIC_GOOGLE_ANALYTICS} />
			<GoogleTagManager gtmId={NEXT_PUBLIC_GOOGLE_TAG_MANAGER} />
		</>
	)
}

export default GoogleTagAnalytics
